"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterBy = filterBy;

function filterBy(option, filter, labelKey) {
  return option[labelKey].toLowerCase().indexOf(filter.toLowerCase()) > -1;
}